import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ArrowRight, Building2, Phone } from 'lucide-react';

export const CTASection = ({ onContactClick }) => {
    const { t } = useTranslation();

    return (
        <section className="py-20 lg:py-28 relative overflow-hidden">
            <div className="absolute inset-0 bg-primary" />
            <div className="absolute inset-0 opacity-10" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }} />
            
            <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-primary-dark/50 to-transparent" />
            <div className="absolute bottom-0 right-0 w-1/2 h-full bg-gradient-to-l from-accent/20 to-transparent" />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6 leading-tight">
                    {t('cta.title1')}{' '}
                    <span className="text-accent-light">{t('cta.title2')}</span>
                </h2>
                
                <p className="text-lg text-primary-foreground/80 max-w-2xl mx-auto mb-10">
                    {t('cta.description')}
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a href="#simulator">
                        <Button 
                            size="lg"
                            className="btn-gold px-8 py-6 rounded-full text-base font-semibold group"
                        >
                            {t('cta.startSimulator')}
                            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                        </Button>
                    </a>
                    <a
                        href="https://www.casaconsulting.ch"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button 
                            variant="outline"
                            size="lg"
                            className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 px-8 py-6 rounded-full text-base font-semibold"
                        >
                            <Building2 className="w-4 h-4 mr-2" />
                            {t('nav.realEstate')}
                        </Button>
                    </a>
                </div>

                <div className="mt-10 flex items-center justify-center gap-2 text-primary-foreground/60">
                    <Phone className="w-4 h-4" />
                    <span className="text-sm">
                        {t('cta.needHelp')} <button onClick={onContactClick} className="text-accent-light hover:underline cursor-pointer">{t('cta.contactTeam')}</button>
                    </span>
                </div>
            </div>
        </section>
    );
};
